import {BaseApi} from './base.api';
import { appPerfMark, appPerfMeasure } from '../utils/appBootstrapPerfLog.js';

export const UserApi = {
  getMyProfile
};

function getMyProfile(){
  appPerfMark('UserApi.myprofile:request');
  return BaseApi.get('/user/myprofile').then((response) => {
    appPerfMeasure('UserApi.myprofile:response', 'UserApi.myprofile:request', {
      status: response?.status
    });
    return response;
  });
}
